export default __webpack_public_path__ + "static/media/3.3a434a4d.jpg";